module.exports = __webpack_public_path__ + "static/img/power2.72e41299.png";